import React, { useState } from "react";
import Layout from "../../Components/Layout";
import Styles from "./index.module.css";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { Services } from "../../Services";
import ReactLoading from "react-loading";
import { warningSwal } from "../../Util/Toast";
import Table from "./Table";
import moment from "moment";

function TotalCustomerReport() {
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState(null);
    const [link, setLink] = useState("");

    const token = { Authorization: `token ${localStorage.getItem("token")}` };

    const handleClear = () => {
        reset();
        setResults(null);
        setLink("");
    };

    const onSubmit = async (data) => {
        if (!data.Date) {
            warningSwal("Warning", "Date is required");
            return;
        }

        setLoading(true);
        try {
            const res = await Services.total_customer_report(
                "GET",
                null,
                token,
                data.Date,
                data.Status || "all"
            );
            setLoading(false);
            if (res?.Status === 1) {
                setLink(res.CsvFile || "");
                setResults(
                    res.Results?.map((item) => ({
                        "Parent Full Name": item.ParentFullName || "NA",
                        "Student Full Name": item.StudentFullName || "NA",
                        "DOB": item.DOB && item.DOB !== "0000-00-00" ? moment(item.DOB).format("DD-MM-YYYY") : "NA",
                        "Primary Phone Number": item.PrimaryPhoneNumber || "NA",
                        "Secondary Phone Number": item.SecondaryPhoneNumber || "NA",
                        "Current Balance": item.CurrentBalance !== undefined && item.CurrentBalance !== null ? Number(item.CurrentBalance).toFixed(2) : "0.00",
                        "Address": [item.Address, item.City, item.State, item.Country, item.Pincode].filter(Boolean).join(", ") || "NA",
                        "Email ID": item.EmailID || "NA",
                    })) || []
                );
            } else {
                console.error(res);
                warningSwal("Warning", res?.message || "Failed to fetch report");
            }
        } catch (err) {
            setLoading(false);
            console.error(err);
            warningSwal("Warning", "Something went wrong");
        }
    };

    return (
        <Layout Active={"Total Customer Report"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Total Customer Report</title>
            </Helmet>
            <div className={Styles["Container"]}>
                <div className={Styles["wrapper"]}>
                    <h3>Total Customer Report</h3>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className={Styles["form-control"]} style={{ flex: 1, minWidth: '200px' }}>
                            <label>Date <span className="important">*</span></label>
                            <input type="date" {...register("Date")} />
                            {errors.Date && <span style={{ color: 'red', fontSize: '12px' }}>Date is required</span>}
                        </div>

                        <div className={Styles["form-control"]} style={{ flex: 1, minWidth: '200px' }}>
                            <label>Status</label>
                            <select {...register("Status")} defaultValue={"all"}>
                                <option value="all">All</option>
                                <option value="active">Active</option>
                                <option value="dormant">Dormant</option>
                            </select>
                        </div>

                        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                            <button
                                type="submit"
                                disabled={loading}
                                className={`${Styles.btn} ${Styles.btnPrimary}`}
                                style={{ alignSelf: "flex-end", marginBottom: errors.Date ? "20px" : "0" }}
                                aria-busy={loading}>
                                <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                                    {loading && <ReactLoading type="spokes" color="#0077b6" height={14} width={14} />}
                                    {loading ? "Submitting..." : "Submit"}
                                </span>
                            </button>

                            <button
                                type="button"
                                className={Styles.btn}
                                style={{
                                    alignSelf: "flex-end",
                                    marginBottom: errors.Date ? "20px" : "0",
                                    backgroundColor: "#f3f4f6",
                                    color: "#374151",
                                    border: "1px solid #d1d5db"
                                }}
                                onClick={handleClear}
                                disabled={loading}>
                                Clear
                            </button>

                            {link && (
                                <button
                                    type="button"
                                    className={`${Styles.btn} ${Styles.btnExport}`}
                                    style={{ alignSelf: "flex-end", marginBottom: errors.Date ? "20px" : "0" }}
                                    onClick={() => window.open(link, "_blank")}>
                                    Export
                                </button>
                            )}
                        </div>
                    </form>

                    {results && (
                        <div style={{ overflow: "auto", marginTop: 16 }}>
                            <Table
                                data={results}
                                emptyHeaders={[
                                    "Parent Full Name",
                                    "Student Full Name",
                                    "DOB",
                                    "Primary Phone Number",
                                    "Secondary Phone Number",
                                    "Current Balance",
                                    "Address",
                                    "Email ID"
                                ]}
                                style={{ minWidth: "1800px" }}
                            />
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
}

export default TotalCustomerReport;
